<template>
  <div class="app-container">
    <el-form :inline="true" :model="searchForm" size="mini">
      <el-row>
        <el-form-item label="产品ID" label-width="70px">
          <el-input v-model.number="searchForm.project_id" type="number" min="0" />
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input v-model.number="searchForm.project_name" style="width:350px" />
        </el-form-item>
        <el-form-item label="创建时间" label-width="70px">
          <el-date-picker
            v-model="searchForm.project_create_date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item>
           <el-button type="primary" @click="search" >查询</el-button>
        <el-button type="warning" @click="clearForm" >重置</el-button>
        <el-button
          v-if="showBtn.add"
          type="primary"
          @click="addVisible = true"

        >新增产品</el-button>
         <el-button
            v-if="showBtn.modules"
             type="primary"

            @click="toAllModules"
          >产品模块</el-button>
        </el-form-item>

      </el-row>
    </el-form>
    <el-table v-loading="tableLoading" :data="tableData" style="width: 100%"
          height="calc(100vh - 230px)">
      <el-table-column label="产品ID" prop="project_id" align="center" width="80"/>
      <el-table-column prop="project_name" label="产品名称"/>
      <el-table-column prop="project_code" label="产品代码" align="center"/>
      <el-table-column prop="project_owner_name" label="产品负责人" align="center"/>
      <el-table-column prop="is_auto_audit" label="是否自动审核" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_auto_audit === 1 ? 'success' : 'danger'">{{ scope.row.is_auto_audit === 1 ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="project_creater_name" label="创建人" align="center"/>
      <el-table-column prop="project_create_date" label="创建时间" align="center"/>
      <el-table-column v-if="showBtn.update || showBtn.modules" label="操作" align="center">
        <template slot-scope="scope">
          <!-- <el-button v-if="showBtn.update" type="primary" size="mini" @click="edit(scope.row)">编辑</el-button> -->
          <el-button v-if="showBtn.update" type="text" @click="powerClick(scope.row)">编辑</el-button>
          <!-- <el-button
            v-if="showBtn.modules"
            type="success"
            size="mini"
            @click="modular(scope.row)"
          >产品模块</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      class="center"
      @pagination="getList"
    />

    <!--新增弹窗-->
    <el-dialog :visible.sync="addVisible" title="新增产品" :close-on-click-modal="false">
      <el-form
        ref="addForm"
        :rules="addRules"
        :model="addForm"
        label-position="left"
        label-width="100px"
        size="mini"
      >
        <el-form-item
          :rules="[{required: true,validator:validateName,trigger:'blur'}]"
          label="产品名称"
          prop="project_name"
        >
          <el-input v-model="addForm.project_name"/>
        </el-form-item>
        <el-form-item label="产品负责人" prop="project_owner">
          <el-select
            v-model="addForm.project_owner"
            :remote-method="getUserInfoByName"
            :loading="selectLoading"
            remote
            reserve-keyword
            filterable
            placeholder="请输入"
            @visible-change="clearSelectList"
            style="width:100%;"
          >
            <el-option
              v-for="item in productOwnerList"
              :key="item.userId"
              :label="`${item.name}（${item.username}）${(item.state !== 1 || item.status !==1)?'(不可用)':''}`"
              :value="item.userId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否自动审核">
          <el-radio-group v-model="addForm.is_auto_audit">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

         <!-- <el-form-item label="拥有模块">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
  <div style="margin: 15px 0;"></div>
  <el-checkbox-group v-model="checkedModel" @change="handleCheckedCitiesChange">
    <el-checkbox v-for="city in modelList" :label="city.model_id" :value="city.model_id" :key="city.model_id">{{city.model_name}}</el-checkbox>
  </el-checkbox-group>
         </el-form-item> -->

        <el-form-item label="产品描述">
          <el-input
            v-model="addForm.project_remark"
            :autosize="{ minRows: 2, maxRows: 6}"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addVisible = false">返回</el-button>
        <el-button size="mini" type="primary" @click="submitAddForm('addForm')">提交</el-button>
      </div>
    </el-dialog>
    <!--编辑弹窗-->
    <el-dialog :visible.sync="editVisible" title="编辑产品" :close-on-click-modal="false">
      <el-form
        ref="editForm"
        :rules="addRules"
        :model="editForm"
        label-position="left"
        label-width="100px"
        size="mini"

      >
        <el-form-item
          :rules="[{required: true,validator:validateName,trigger:'blur'}]"
          label="产品名称"
          prop="project_name"
        >
          <el-input v-model="editForm.project_name"/>
        </el-form-item>
        <!-- <el-form-item label="产品代码" prop="project_id">
          <el-input v-model="editForm.project_id" disabled/>
        </el-form-item> -->
        <el-form-item label="产品负责人" prop="project_owner">
          <el-select
            v-model="editForm.project_owner"
            :remote-method="getUserInfoByName"
            :loading="selectLoading"
            remote
            reserve-keyword
            filterable
            placeholder="请输入"
            @visible-change="clearSelectList"
             style="width:100%;"
          >
            <el-option
              v-for="item in productOwnerList"
              :key="item.userId"
              :label="`${item.name}（${item.username}）${(item.state !== 1 || item.status !==1)?'(不可用)':''}`"
              :value="item.userId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否自动审核">
          <el-radio-group v-model="editForm.is_auto_audit">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="拥有模块">
        <!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox> -->
  <div style="margin: 15px 0;"></div>
  <el-checkbox-group v-model="checkedModel" @change="handleCheckedCitiesChange">
    <el-checkbox v-for="city in moddleEditList" :label="city.model_id" :value="city.model_id" :key="city.model_id" :disabled="city.pm_state==1?true:false">{{city.model_name}}</el-checkbox>
  </el-checkbox-group>
         </el-form-item>

        <el-form-item label="产品描述">
          <el-input
            v-model="editForm.project_remark"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="editVisible = false">返回</el-button>
        <el-button size="mini" type="primary" @click="submitEditForm('editForm')">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Pagination from '@/components/Pagination'
import * as productApi from '@/api/product'
import * as loginApi from '@/api/login'
export default {
  components: { Pagination },
  data() {
    return {
      searchForm: {
        project_id: null,
        project_name: '',
        project_create_date: []
      },
      tableData: [],
      tableLoading: false,
      total: 1,
      listQuery: {
        page: 1,
        limit: 20,
        importance: undefined,
        title: undefined,
        type: undefined,
        sort: '+id'
      },
      // 新增弹窗
      addVisible: false,
      addForm: {
        project_name: '',
        project_owner: '',
        is_auto_audit: 0,
        project_remark: '',
        project_models: '',
        project_creater: ''
      },
      addRules: {
        project_name: [],
        project_owner: [
          { required: true, message: '产品负责人不能为空', trigger: 'blur' }
        ]
      },
      selectLoading: false,
      productOwnerList: [],
      // 编辑弹窗
      editVisible: false,
      editForm: {
        name: '',
        personCode: 1,
        personName: '',
        describe: '',
        project_models: [],
        project_remark: '',
        project_name: '',
        is_auto_audit: 0
      },
      showBtn: {
        add: false,
        update: false,
        modules: false
      },
      powerList: [], // 所有模块列表
      project_owner_userList: [], // 负责人列表
      checkAll: false, // 默认全选状态false
      checkedModel: [], // 选中的模块，[1,2,3]
      modelList: [], // 所有数据 [{label:"模块1"，id:1},{label:"模块2"，id:2}...]
      isIndeterminate: false, // 图标
      cityOptions: [], // 所有选中的id [1,2,3,4,5,6...]
      moddleEditList: []
    }
  },
  computed: {
    ...mapGetters(['userId', 'size', 'actionUrl'])
  },
  created() {
    this.getList()
    this.isShowBtn()
    this.getAllMd()
  },
  methods: {
    isShowBtn() {
      for (const i of this.actionUrl) {
        if (i.url === '/allProduct/addProduct') {
          this.showBtn.add = true
        }
        if (i.url === '/allProduct/editProduct') {
          this.showBtn.update = true
        }
        if (i.url === '/allProduct/productModular') {
          this.showBtn.modules = true
        }
      }
    },
    getList() {
      this.tableLoading = true
      productApi.getAllProduct({ user_id: this.userId })
        .then(response => {
          const responseData = response.data.data
          if (responseData.length === 0) {
            this.tableLoading = false
          }
          return responseData
        })
        .then(responseData => {
          const project_owner_id_list = []
          const project_creater_list = []

          for (const i in responseData) {
            project_owner_id_list.push(responseData[i].project_owner)
            project_creater_list.push(responseData[i].project_creater)
          }
          if (
            project_owner_id_list.length > 0 &&
            project_creater_list.length > 0
          ) {
            const p1 = this.getUserInfoByIdListFun(responseData, project_owner_id_list, 'project_owner', 'project_owner_name')
            const p2 = this.getUserInfoByIdListFun(responseData, project_creater_list, 'project_creater', 'project_creater_name')
            Promise.all([p1, p2]).then(() => {
              this.tableData = responseData
              this.tableLoading = false
            })
          }
        })
    },
    getUserInfoByIdListFun(responseData, userIds, project_user, project_user_name) {
      const reqeustmethods = loginApi.getUserInfoByIdList({
        userIds: userIds
      }).then(res => {
        const userData = res.data
        for (const i in responseData) {
          for (const j in userData) {
            if (responseData[i][project_user] === userData[j].userId) {
              responseData[i][project_user_name] = `${userData[j].name}(${userData[j].username})`
            }
          }
        }
      })
      return reqeustmethods
    },
    search() {
      console.log(this.searchForm)
      this.tableLoading = true
      // const params = {
      //   user_id: this.userId,
      //   project_id: this.searchForm.project_id,
      //   project_name: this.searchForm.project_name
      // }

      const params = Object.assign({}, this.searchForm, { user_id: this.userId })
      if (this.searchForm.project_create_date) {
        params.project_create_date_start = this.searchForm.project_create_date[0]
        params.project_create_date_end = this.searchForm.project_create_date[1]
      }
      if (!this.searchForm.project_name) {
        delete params.project_name
      }
      productApi.getProductByInfo(params)
        .then(response => {
          const responseData = response.data
          if (responseData.length === 0) {
            this.tableData = []
            this.tableLoading = false
          }
          return responseData
        })
        .then(responseData => {
          const project_owner_id_list = []
          const project_creater_list = []
          for (const i in responseData) {
            project_owner_id_list.push(responseData[i].project_owner)
            project_creater_list.push(responseData[i].project_creater)
          }
          if (
            project_owner_id_list.length > 0 &&
            project_creater_list.length > 0
          ) {
            const p1 = loginApi.getUserInfoByIdList({
              userIds: project_owner_id_list
            }).then(res => {
              const userData = res.data
              for (const i in responseData) {
                for (const j in userData) {
                  if (responseData[i].project_owner === userData[j].userId) {
                    responseData[i].project_owner_name = `${userData[j].name}(${userData[j].username})`
                  }
                }
              }
            })
            const p2 = loginApi.getUserInfoByIdList({
              userIds: project_creater_list
            }).then(res => {
              const userData = res.data
              for (const i in responseData) {
                for (const j in userData) {
                  if (responseData[i].project_creater === userData[j].userId) {
                    responseData[i].project_creater_name = `${userData[j].name}(${userData[j].username})`
                  }
                }
              }
            })
            Promise.all([p1, p2]).then(() => {
              this.tableData = responseData
              this.tableLoading = false
            })
          }
        })
    },
    clearForm() {
      this.searchForm = {
        project_id: null,
        project_name: '',
        project_create_date: []
      }
    },
    // 产品负责人select框的值   即模糊查询用户
    getUserInfoByName(query) {
      if (query !== '') {
        this.selectLoading = true
        const params = {
          name: query,
          pageNum: 1,
          pageSize: 10
        }
        loginApi.getUserInfoByName(params).then(res => {
          this.productOwnerList = res.data.list
          this.selectLoading = false
        })
      }
    },
    // 选中之后清空用户list
    clearSelectList(val) {
      if (val === false) {
        this.productOwnerList = []
      }
    },
    // table中的编辑触发函数，先对产品负责人选项框数据清空，避免污染
    edit(rowData) {
      this.productOwnerList = []
      loginApi.getUserInfoById(rowData.project_owner)
        .then(res => {
          this.productOwnerList.push(res.data)
          this.editForm = rowData
          this.editVisible = true
        })
        .catch(() => {})
    },
    modular(val) {
      const name = encodeURIComponent(val.project_name)
      this.$router.push({
        path: `/system/product_module/${val.project_id}/${name}`
      })
    },
    // 新增产品弹窗
    validateName(rule, value, callback) {
      // 校验产品名称不可与系统内已有产品名称重复
      if (value === '') {
        callback(new Error('请填写产品名'))
      } else {
        callback()
      }
    },
    // 新增产品提交表单
    submitAddForm(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.addForm.project_creater = this.userId
          // this.addForm.project_models = JSON.parse(JSON.stringify(this.checkedModel));
          productApi.addProduct(this.addForm).then(res => {
            if (res.code === '200') {
              this.getList()
              this.$message({
                message: '新增成功!',
                type: 'success'
              })
              this.addVisible = false
            }
          })
        } else {
          return false
        }
      })
    },
    // 编辑产品弹窗
    submitEditForm(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.editForm.user_id = this.userId
          this.editForm.project_models = JSON.parse(JSON.stringify(this.checkedModel))
          productApi.editProduct(this.editForm).then(res => {
            if (res.code === '200') {
              this.getList()
              this.$message({
                message: '修改成功!',
                type: 'success'
              })
              this.editVisible = false
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          return false
        }
      })
    },
    // 跳转到产品模块页面
    toAllModules() {
      this.$router.push({ name: 'allModules' })
    },
    // 获取所有模块
    getAllMd() {
      this.tableLoading = true
      productApi.getAllModules().then(res => {
        this.modelList = res.data
        for (const item of res.data) {
          this.cityOptions.push(item.model_id)
        }
      }).catch(() => {
      })
    },

    // 点击编辑
    powerClick(rowData) {
      this.productOwnerList = []
      // 填充编辑表单
      this.editForm.project_id = rowData.project_id
      this.editForm.project_name = rowData.project_name
      this.editForm.project_owner = rowData.project_owner
      this.editForm.is_auto_audit = rowData.is_auto_audit
      this.editForm.project_remark = rowData.project_remark
      // 获取负责人
      loginApi.getUserInfoById(rowData.project_owner)
        .then(res => {
          this.productOwnerList.push(res.data)
          // this.editForm = rowData;
          this.editVisible = true
        })
        .catch(() => {})
      // 获取该产品拥有的模块
      this.checkedModel = []// 选中的模块id；全选中的是this.cityOptions 数组所有的模块id,
      this.checkAll = false
      this.isIndeterminate = false
      productApi.getProModule(this.editForm.project_id).then(response => {
        // 根据一个状态判断不能取消勾选  绑定属性disabled
        this.moddleEditList = []
        this.editForm.project_models = []
        this.moddleEditList = JSON.parse(JSON.stringify(this.modelList))
        for (const item of response.data) {
          if (item.model_id > 0) {
            this.editForm.project_models.push(item.model_id)
            this.checkedModel.push(item.model_id)
          }
          for (let i = 0; i < this.moddleEditList.length; i++) {
            if (item.pm_state === 1 && this.moddleEditList[i].model_id === item.model_id) {
              this.moddleEditList[i].pm_state = item.pm_state
            }
          }
        }// 判断结束
        // console.log('修改后的',this.moddleEditList)
      })
    },
    handleCheckAllChange(val) {
      this.checkedModel = val ? this.cityOptions : [] // cityOptions数组所有的模块id, 当全选为true的时候，把数组的值全部赋值给它
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.modelList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.modelList.length
    }
    // 勾选结束
    // 点击新增
    // addClick(){
    //   this.checkedModel=[];//选中的模块id；全选中的是this.cityOptions 数组所有的模块id,
    //   this.checkAll = false;
    //   this.isIndeterminate = false,
    //   this.addVisible = true
    // }
  }
}
</script>
<style lang="scss" scope>
.center {
  text-align: center;
}
.applegreen{
  background-color: green;
}
.pan-btn{
  margin-bottom: 5px;
}
</style>
